const sharedBoxStyles = {
  display: 'grid',
  gap: {md: '1rem', sm: '0.5rem'},
  gridTemplateColumns: 'repeat(4, 1fr)',
  mt: '1rem',
  '& .MuiCard-root:hover': {
    boxShadow: 'none !important'
  }
};

export default sharedBoxStyles;
